import { cn } from "@/lib/utils";

function Skeleton({
  className,
  style,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse bg-muted", className)}
      style={{ borderRadius: "var(--radius)", ...style }}
      {...props}
    />
  );
}

export { Skeleton };
